module.exports = __webpack_public_path__ + "img/New Zealand.a57708c5.svg";